import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/multiple_white.png")